import { LOC_TRIGGER_VALIDATION_ERROR } from "../../locKeys";
import { getErrorMessage } from "../utils";

export abstract class Trigger {
    /**
     * Validuje spouštěč. V případě problému vyhodí výjimku.
     */
    public abstract validate(): Promise<void>;

    /**
     * Sestavuje lokalizovanou error zprávu o nevyplněných atriutech.
     * @param attrNameLocKey Název nevyplněného povinného atributu.
     * @param triggerNameLocKey Název spouštěče.
     */
    public async getTriggerErrorMessage(attrNameLocKey: string, triggerNameLocKey: string): Promise<string> {
        return getErrorMessage(attrNameLocKey, triggerNameLocKey, LOC_TRIGGER_VALIDATION_ERROR);
    }
}
